import { render, staticRenderFns } from "./FormPlan.vue?vue&type=template&id=ef4d44d6&"
import script from "./FormPlan.vue?vue&type=script&lang=js&"
export * from "./FormPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports